module.exports = __webpack_public_path__ + "static/media/process-flow-3-icon.611d2e72.svg";